import script from "./share-trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./share-trigger.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__